<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true">
    </loading>
    <!-- <FORM NAME="FROM1" ACTION="https://testtrustlink.hitrust.com.tw/TrustLink/TrxReqForJava" METHOD="POST" > -->
    <FORM NAME="FROM1" ACTION="https://exam.cerps.org.tw/study-0.0.1-SNAPSHOT/TrustLink/TrxReqForJava" METHOD="POST" >
    <v-row class="text-left search-bar">
      <v-col class="pt-4 pl-0 col-9 col-md-8">
        <v-tabs class="ml-6 tabsLeft" color="#215DA7"  v-model="tab">
          <v-tabs-slider color="#215DA7"></v-tabs-slider>
          <v-tab><span style="font-size:15pt; font-weight:550">報名資訊</span></v-tab>
          <v-tab v-show="datasets.payGroup == '2' && ((datasets.payStatus == '1') || (datasets.payStatus == '5') || (datasets.payStatus == '6'))"
                ><span style="font-size:15pt; font-weight:550">前往繳費</span></v-tab>
          <v-tab v-show="examTimeNow"><span style="font-size:15pt; font-weight:550">各式申請總表</span></v-tab>
        </v-tabs>
      </v-col>
      <v-col v-if="tab==0" class="py-3 text-right pr-10 col-3 col-md-4">
        <!-- APP -->
        <!-- <div class="menuApp" style="display: none"> -->
        <div>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" class="appBtn" style="display: none">
                <v-icon style="color:#FFF">mdi-menu-down</v-icon>
              </v-btn>
              <v-btn icon v-bind="attrs" v-on="on" class="webBtn" style="width:160px; border-radius:8px; color:#FFFFFF">
                <span class="px-2 menuAppBtn">功能選單</span>
                <v-icon style="color:#FFF">mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list style="width: 200px;cursor: pointer">
              <v-list-item v-if="(datasets.payStatus == '3') || (datasets.payStatus == '4')"
                @click="$refs.ShowMsg.open(19)">
                <v-list-item-title>
                  <v-icon class="pr-2" size="16">mdi-close-octagon-outline</v-icon>
                  <span>取消報名</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="(datasets.payStatus == '1') ||(datasets.payStatus == '2') || (datasets.payStatus == '5') || (datasets.payStatus == '6')"
                @click="$refs.DeleteConfirm.open(2,'','',true)">
                <v-list-item-title>
                  <v-icon class="pr-2" size="16">mdi-close-octagon-outline</v-icon>
                  <span>取消報名</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="$refs.AdjustmentRegister.open()">
                <v-list-item-title>
                  <v-icon class="pr-2" size="16">mdi-pencil</v-icon>
                  <span>修改報名資料</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="datasets.receiptPrintCount == '2'" @click="getReceiptPdf()">
                <v-list-item-title>
                  <v-icon class="pr-2" size="16">mdi-cloud-print-outline</v-icon>
                  <span>下載收據</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="datasets.payStatus!= '5' && datasets.examPass" @click="getTranscriptPdf()">
                <v-list-item-title>
                  <v-icon class="pr-2" size="16">mdi-download-multiple</v-icon>
                  <span>下載成績單</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="datasets.payStatus!= '5' && datasets.certificatePrintCount == '2'" @click="getCertificatePdf()">
                <v-list-item-title>
                  <v-icon class="pr-2" size="16">mdi-printer</v-icon>
                  <span>下載證書</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-col>

      <v-col v-if="tab==2" class="py-3 text-right pr-10 col-3 col-md-4">
        <!-- APP -->
        <div>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" class="appBtn" style="display: none">
                <v-icon style="color:#FFF">mdi-menu-down</v-icon>
              </v-btn>
              <v-btn icon v-bind="attrs" v-on="on" class="webBtn" style="width:160px; border-radius:8px; color:#FFFFFF">
                <span class="px-2 menuAppBtn">功能選單</span>
                <v-icon style="color:#FFF">mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list style="width: 200px;cursor: pointer">
              <v-list-item @click="redirectPath('/applyCertificatePersonal', -1)">
                <v-list-item-title>
                  <span>前往各式申請</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-col>
    </v-row>

    <div v-if="tab==0" id="router" :style="viewStyle">
      <div id="box" class="pa-5" style="margin-top:3%;">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
          <h4 class="DarkBlue pt-1">考試資訊</h4>
        </v-row>
        <v-row class="mx-2">
          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>場次代碼</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.examNo"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>考試方式</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-select class="text_field" dense readonly background-color="#F4F8F9" outlined style="-webkit-text-fill-color: #000"
                :items="examMethodList" item-text="title" item-value="valuev" v-model="datasets.exportStatus">
                  <template v-slot:append>
                    <v-icon></v-icon>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證考場</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="companyInfo"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證日期</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="examDate"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>繳費方式</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="payGroup"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證項目</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.class1"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證模組</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.class2"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證廠商</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.class3"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證費用</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.examFee"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="2" class="py-0 pl-0">
                <div class="text-right pt-1 ml-0 pt14" style="line-height:1.2"><span class="start">*</span>報名繳費截止日期</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="deadline"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <div id="box" class="pa-5 mt-3 my-10">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
          <h4 class="DarkBlue pt-1">考生資訊</h4>
        </v-row>
        <v-row class="mx-2">
          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>中文姓名</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.name"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>羅馬拼音</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined placeholder="請務必填寫正確護照姓名，若需修正需付費申請" v-model="datasets.englishName"></v-text-field>
              </v-col>
              <!-- <v-col cols="1" class="pa-0 pt-2 ml-n2">
                <a href="https://www.boca.gov.tw/sp-natr-singleform-1.html" target="_blank" class="pt14">同護照</a>
              </v-col> -->
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>身分證字號(ID)</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.idCard"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>出生年月日</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.birthday"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 py-1">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>性別</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0 pt-2 pl-5">
                <v-radio-group class="ma-0 pa-0" dense readonly v-model="datasets.gender">
                  <v-row>
                    <v-radio class="pr-2" value="0" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">女</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="1" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">男</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="2" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">不提供</span>
                      </template>
                    </v-radio>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>電子信箱</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.email"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>學校/單位名稱</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-select class="text_field" dense readonly background-color="#F4F8F9" outlined style="-webkit-text-fill-color: #000"
                :items="collegeCategoryList" item-text="title" item-value="valuev" v-model="datasets.collegeCategory">
                  <template v-slot:append>
                    <v-icon></v-icon>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4"></v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.company"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>系所/部門</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.department"></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14">聯絡電話</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.tel"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>行動電話</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.ctel"
                @keyup="[datasets.ctel= datasets.ctel.replace(/\D/g,'')]" :maxlength="10"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0" v-if="datasets.citizenShip=='1' || !datasets.citizenShip">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>郵遞區號</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.zipCode"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>通訊地址</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-row class="px-3" v-if="datasets.citizenShip=='1' || !datasets.citizenShip">
                  <v-text-field class="text_field mr-2" dense readonly background-color="#F4F8F9" outlined v-model="datasets.country"></v-text-field>
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.area"></v-text-field>
                </v-row>
                <v-row class="px-3">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.address"></v-text-field>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="ma-0 py-1">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>企業徵才用</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0 pt-2 pl-5">
                <v-radio-group class="ma-0 pa-0" dense readonly v-model="datasets.recruitmentAgree">
                  <v-row class="mr-0 pa-0">
                    <v-radio class="pr-2" value="1" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">同意</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="0" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">不同意</span>
                      </template>
                    </v-radio>
                    <div class="ma-0 pa-0" @mouseenter="mouseInfor=1" @mouseout="mouseInfor=0">
                      <v-icon style="background:#FFF">mdi-alert-circle-outline</v-icon>
                    </div>
                    <div v-if="mouseInfor==1" class="mt-n2 px-2 border absolute" style="width:220px; height:96px">
                      <h4 class="px-2 pt-3" style="font-size:12pt">※ 已同意將個資提供中華企業資源規劃學會使用</h4>
                      <h4 class="px-2 pb-3" style="font-size:12pt">我願意被企業徵才查詢</h4>
                    </div>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="ma-0 py-1">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>報考身份別</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0 pt-2 pl-5">
                <v-radio-group class="ma-0 pa-0" dense readonly v-model="datasets.examMemberType">
                  <v-row>
                    <v-radio v-if="datasets.examMemberType == 1" class="pr-2" value="1" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">一般</span>
                      </template>
                    </v-radio>
                    <v-radio v-if="datasets.examMemberType != 1" class="pr-2" value="2" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">一般</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" v-if="datasets.examMemberType == 3" value="3" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">老師</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="4" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">身心障礙</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="5" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">低收入戶</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="6" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">其他</span>
                      </template>
                    </v-radio>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>收據抬頭</div>
              </v-col>
              <v-col class="col-9 col-sm-7 col-md-5">
                <v-text-field class="text_field" dense outlined placeholder="請輸入收據抬頭" readonly background-color="#F4F8F9"
                  v-model="datasets.receiptTitle">
                </v-text-field>
              </v-col>
              <v-col class="col-6 col-sm-3 col-md-5 pt-1">
                <v-checkbox class="ma-0 pa-0" readonly v-model="datasets.sameName">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">與中文姓名同</span>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mx-2">
          <v-col class="px-0 col-2">
            <div class="text-right pt-2 pt14"><span class="start">*</span>職稱</div>
          </v-col>
          <v-col v-if="memberType!='erpTeacher'" class="col-10 col-md-8 py-0 pt-2 pl-5">
            <v-radio-group class="ma-0 pa-0" dense readonly v-model="datasets.jobtitle">
              <v-row>
                <v-radio class="pr-2" value="1" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">高中生(含五專)</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="2" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">大學生</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="3" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">碩士生</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="4" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">博士生</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="5" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">教師</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="6" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">社會人士</span>
                  </template>
                </v-radio>
              </v-row>
            </v-radio-group>
          </v-col>
          <v-col v-if="memberType=='erpTeacher'" class="col-10 col-md-4 py-0">
            <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined placeholder="請輸入職稱" v-model="datasets.jobtitle"></v-text-field>
          </v-col>
        </v-row>
      </div>
    </div>
    <div v-if="tab==1" id="router" :style="viewStyle">
      <div id="box" class="pa-5" style="margin-top:3%">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
          <h4 class="DarkBlue pt-1">考試資訊確認</h4>
        </v-row>
        <v-row>
          <v-col cols="2">
            <div class="text-right pt-2 pt14"><span class="start">*</span>報考場次</div>
          </v-col>
          <v-col cols="9">
            <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.examNo"></v-text-field>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col cols="2">
            <div class="text-right pt-2 pt14"><span class="start">*</span>繳費金額</div>
          </v-col>
          <v-col cols="9">
            <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.realPay"></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="datasets">
          <v-col cols="2">
            <div class="text-right pt-2 pt14">認證折扣代碼</div>
          </v-col>
          <v-col cols="9" class="pt-1 pl-5">
            <v-radio-group class="ma-0 pa-0" dense :readonly="(couponFix)" v-model="couponHave">
              <v-row class="my-1">
                <v-radio class="pr-2" value="0" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">無</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="1" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">有</span>
                  </template>
                </v-radio>
              </v-row>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row v-if="couponHave=='1'">
          <v-col cols="2">
          </v-col>
          <v-col v-if="datasets" cols="6">
            <v-text-field class="text_field" dense outlined placeholder="請輸入認證折扣代碼" v-model="datasets.couponNo"
            :readonly="(couponFix)" :background-color="(couponFix)?'#F4F8F9':'#FFF'"
            @keyup="datasets.couponNo = datasets.couponNo.replace(/[\u4e00-\u9fa5]/ig,''), datasets.couponNo = $Global.toCDB(datasets.couponNo)"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-btn outlined style="width:100%; height:40px; background:#81c0e2; border-radius:8px; border:none" @click="checkCouponNo()">
              <span style="color:#FFFFFF">審核</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="couponHave=='1' && couponFix">
          <v-col cols="2">
            <div class="text-right pt-2 pt14"><span class="start">*</span>折抵金額</div>
          </v-col>
          <v-col cols="9">
            <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.couponPrice"></v-text-field>
          </v-col>
        </v-row> -->
        <v-row>
          <v-col cols="2">
            <div class="text-right pt-2 pt14"><span class="start">*</span>繳費金額</div>
          </v-col>
          <v-col cols="9">
            <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.havePay"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="py-1">
          <v-col cols="2">
            <div class="text-right pt-2 pt14"><span class="start">*</span>繳費方式</div>
          </v-col>
          <v-col cols="9" class="py-0 pt-2 pl-5">
            <v-radio-group class="ma-0 pa-0" dense v-model="payment">
              <v-row>
                <v-radio class="pr-2" value="0" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">信用卡繳款</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="1" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">ATM、銀行郵局臨櫃繳款</span>
                  </template>
                </v-radio>
                <!-- <v-radio class="pr-2" value="2" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">LINE Pay</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="3" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">銀聯卡</span>
                  </template>
                </v-radio> -->
              </v-row>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <div class="text-right pt-2 pt14"><span class="start">*</span>繳費期限</div>
          </v-col>
          <v-col cols="9">
            <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="deadline"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0 pt14" justify="center">
          <h4 v-if="datasets.paymentNo && datasets.paymentNo != '請至信箱收信或聯繫學會人員取得繳費帳號'" class="py-3 px-6" style="padding-top:2px; color:#F00">
            您的ATM、銀行郵局臨櫃繳款帳號：{{datasets.paymentNo}}
          </h4>
        </v-row>
      </div>
      <div> 
        <v-row class="ma-0 pa-0 pt14" justify="center">
          <h4 class="py-3 px-6" style="padding-top:2px">
            *為因應後續認證考試處理作業，最晚請於考試前10天前往繳費，逾期視同放棄本次報名，系統將予以自動刪除！
          </h4>
        </v-row>
        <v-row class="ma-0 pa-0 pt14" justify="center">
          <v-btn v-if="datasets.havePay=='0'" class="mb-5 col-8 col-sm-5 col-md-4 col-lg-3" outlined style="height:40px; background:#939C99; border-radius:8px; border:none"
            @click="$refs.ShowMsg.open(0,'系統提示','您的繳費金額為0元，請聯繫學會人員(電話：03- 4264248)進行金額及狀態確認。')">
            <span style="color:#FFFFFF">下一步，進行繳費</span>
          </v-btn>
          <v-btn v-if="datasets.havePay!='0'" class="mb-5 col-8 col-sm-5 col-md-4 col-lg-3" outlined style="height:40px; background:#81c0e2; border-radius:8px; border:none" 
          @click="e17Date = datasets.deadlineDate.substring(0,10).replaceAll('-',''); confirmOrder()">
            <span style="color:#FFFFFF">下一步，進行繳費</span>
          </v-btn>
        </v-row>
      </div>
    </div>

    <div v-if="tab==2" id="router" :style="viewStyle">
      <v-simple-table id="tablebox" fixed-header height="670px" class="pa-3" style="margin: 3% 5.8% 4% 4%">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center pl-7" @click="sort('applyCode')">申請編號 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('applyItem')">申請項目 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('applyFee')">申請費用 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('paymentMethod')">繳費方式 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('paymentStatus')">繳費狀態 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('paymentDeadline')">繳費期限 <v-icon small>icon-form_sort_off</v-icon></th>
              <th @click="sort('deliveryStatus')">證書發送狀態 <v-icon small>icon-form_sort_off</v-icon></th>
              <th>功能</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data,index) in certificateDeliveryList" :key="index">
              <td class="text-center pt-2 pb-1" style="min-width: 100px">
                <v-btn class="text-center" outlined style="height:28px; background:#215DA7; color:#FFF" @click="redirectPath('/applyCertificatePersonal', data.id)"><span style="font-size:14px">查看</span></v-btn>
                <h4 class="text-center">{{data.applyCode}}</h4>
              </td>
              <td style="min-width: 110px"><h4>{{$Global.getTypevDescription(applyItemList,data.applyItem)}}</h4></td>
              <td style="min-width: 110px"><h4>{{data.applyFee}}元</h4></td>
              <td style="min-width: 110px"><h4>{{paymentMethod[data.paymentMethod]}}</h4></td>
              <td style="min-width: 110px"><h4>{{(data.paymentStatus=='1') ? '已繳費': (data.paymentStatus=='2') ? '未繳費': ''}}</h4></td>
              <td style="min-width: 120px"><h4>{{data.paymentDeadline}}</h4></td>
              <td style="min-width: 140px"><h4>{{(data.deliveryStatus=='0') ? '申請中': (data.deliveryStatus=='1') ? '已寄出': (data.deliveryStatus=='2') ? '已變更': (data.deliveryStatus=='3') ? '已退費': (data.deliveryStatus=='4') ? '取消申請':''}}</h4></td>
              <td style="min-width: 260px" class="text-left">
                <v-btn v-if="data.deliveryStatus == '0' && data.paymentStatus == '2' && (new Date(nowTime) < new Date(data.paymentDeadline + ' 23:59:59'))  && ((data.paymentMethod == '0') || (data.paymentMethod == '1' && (!data.paymentNo || data.paymentNo == '請至信箱收信或聯繫學會人員取得繳費帳號')))" outlined style="height:30px; background:#81C0E2; color:#FFF" 
                  @click="e17Date = data.paymentDeadline.replaceAll('-',''); setCertificateDelivery(index)">
                  <!-- @click="e17Date = data.paymentDeadline.replaceAll('-',''); createApplyOrder(data.applyCode, data.applyFee, data.paymentMethod)"> -->
                  <v-icon class="pr-1" size="16">mdi-credit-card-plus</v-icon>
                  <span style="font-size:14px">前往繳費</span>
                </v-btn>
                <h4 v-if="data.paymentMethod == '1' && data.paymentNo && data.paymentNo != '請至信箱收信或聯繫學會人員取得繳費帳號'">ATM繳費帳號: {{data.paymentNo}}</h4>
                <h4 v-if="data.paymentStatus=='1' && data.deliveryStatus=='4'" style="color:#F00">請主動來信至service@cerps.org.tw</h4>
                <h4 v-if="data.paymentStatus=='1' && data.deliveryStatus=='4'" style="color:#F00">索取退款申請書(須支付行政處理費)</h4>
              </td>
              <td style="min-width: 100px">
                <v-btn v-if="data.receiptPrintCount == '2' && data.deliveryStatus != '3' && data.deliveryStatus != '4'" outlined style="height:30px; background:#81C0E2; color:#FFF" @click="getReceiptAppendPdf(data.id)">
                  <v-icon class="pr-1" size="16">mdi-cloud-print-outline</v-icon>
                  <span style="font-size:14px">下載證書申請收據</span>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
	
    <!--信用卡繳款-->
    <div style="display:none" v-if="expectPaymentMethod.includes('0')" >
      <INPUT TYPE="TEXT" NAME="Type" value="Auth"></INPUT>
      <v-text-field TYPE="TEXT" NAME="storeid" v-model="hiTrustStoreList[0].storeid"></v-text-field>
      <v-text-field TYPE="TEXT" NAME="ordernumber" v-model="mOrderNumber"></v-text-field>
      <v-text-field TYPE="TEXT" NAME="amount" v-model="mOrderFee"></v-text-field>
      <INPUT TYPE="TEXT" NAME="orderdesc" value="認證鑑定費用"></INPUT>
      <INPUT TYPE="TEXT" NAME="depositflag" value="1"></INPUT>
      <INPUT TYPE="TEXT" NAME="queryflag" value="1"></INPUT>
      <INPUT TYPE="TEXT" NAME="pan" value=""></INPUT>
      <INPUT TYPE="TEXT" NAME="expiry" value=""></INPUT>
      <INPUT TYPE="TEXT" NAME="e01" value=""></INPUT>
      <v-text-field TYPE="TEXT" NAME="returnURL" v-model="hiTrustServiceList[1].url"></v-text-field>
      <v-text-field TYPE="TEXT" NAME="merUpdateURL" v-model="hiTrustServiceList[2].url"></v-text-field>
      <button ref="submit" >Submit</button>
      <INPUT TYPE="SUBMIT" VALUE="執行" >AAA</INPUT>
    </div>
    
    <!--虛擬帳號-->
    <div style="display:none" v-if="expectPaymentMethod.includes('1')" >
      <INPUT TYPE="TEXT" NAME="Type" value="VIRTUAL"></INPUT>
      <v-text-field TYPE="TEXT" NAME="storeid" v-model="hiTrustStoreList[1].storeid"></v-text-field>
      <v-text-field TYPE="TEXT" NAME="ordernumber" v-model="mOrderNumber"></v-text-field>
      <v-text-field TYPE="TEXT" NAME="amount" v-model="mOrderFee"></v-text-field>
      <INPUT TYPE="TEXT" NAME="queryflag" value="1"></INPUT>
      <INPUT TYPE="TEXT" NAME="orderdesc" value="認證鑑定費用"></INPUT>
      <v-text-field TYPE="TEXT" NAME="e17" v-model="e17Date"></v-text-field>
      <v-text-field TYPE="TEXT" NAME="returnURL" v-model="hiTrustServiceList[1].url"></v-text-field>
      <v-text-field TYPE="TEXT" NAME="merUpdateURL" v-model="hiTrustServiceList[2].url"></v-text-field>
      <button ref="submit" >Submit</button>
      <INPUT TYPE="SUBMIT" VALUE="執行" >AAA</INPUT>
    </div>
    
    <!--LINE Pay-->
    <div style="display:none" v-if="expectPaymentMethod.includes('2')" >
      <INPUT TYPE="TEXT" NAME="Type" value="Auth"></INPUT>
      <v-text-field TYPE="TEXT" NAME="storeid" v-model="hiTrustStoreList[2].storeid"></v-text-field>
      <v-text-field TYPE="TEXT" NAME="ordernumber" v-model="mOrderNumber"></v-text-field>
      <v-text-field TYPE="TEXT" NAME="amount" v-model="mOrderFee"></v-text-field>
      <INPUT TYPE="TEXT" NAME="orderdesc" value="認證鑑定費用"></INPUT>
      <INPUT TYPE="TEXT" NAME="depositflag" value="1"></INPUT>
      <INPUT TYPE="TEXT" NAME="queryflag" value="1"></INPUT>
      <v-text-field TYPE="TEXT" NAME="returnURL" v-model="hiTrustServiceList[1].url"></v-text-field>
      <v-text-field TYPE="TEXT" NAME="merUpdateURL" v-model="hiTrustServiceList[2].url"></v-text-field>
      <button ref="submit" >Submit</button>
      <INPUT TYPE="SUBMIT" VALUE="執行" >AAA</INPUT>
    </div>
    
    <!--銀聯卡-->
    <div style="display:none" v-if="expectPaymentMethod.includes('3')" >
      <INPUT TYPE="TEXT" NAME="Type" value="UPOP_AUTH"></INPUT>
      <v-text-field TYPE="TEXT" NAME="storeid" v-model="hiTrustStoreList[3].storeid"></v-text-field>
      <v-text-field TYPE="TEXT" NAME="ordernumber" v-model="mOrderNumber"></v-text-field>
      <v-text-field TYPE="TEXT" NAME="amount" v-model="mOrderFee"></v-text-field>
      <INPUT TYPE="TEXT" NAME="orderdesc" value="認證鑑定費用"></INPUT>
      <INPUT TYPE="TEXT" NAME="depositflag" value="1"></INPUT>
      <INPUT TYPE="TEXT" NAME="queryflag" value="1"></INPUT>
      <INPUT TYPE="TEXT" NAME="pan" value=""></INPUT>
      <INPUT TYPE="TEXT" NAME="expiry" value=""></INPUT>
      <INPUT TYPE="TEXT" NAME="e01" value=""></INPUT>
      <v-text-field TYPE="TEXT" NAME="returnURL" v-model="hiTrustServiceList[1].url"></v-text-field>
      <v-text-field TYPE="TEXT" NAME="merUpdateURL" v-model="hiTrustServiceList[2].url"></v-text-field>
      <button ref="submit" >Submit</button>
      <INPUT TYPE="SUBMIT" VALUE="執行">AAA</INPUT>
    </div>
    </FORM>
    <ShowMsg ref="ShowMsg" :onSave="onShowMsg"/>
    <ShowMsgAtm ref="ShowMsgAtm" :onSave="onShowMsgAtm"/>
    <ShowConfirm ref="ShowConfirm" :onSave="onShowConfirm"/>
    <AdjustmentRegister ref="AdjustmentRegister" />
    <DeleteConfirm ref="DeleteConfirm" :onSave="deleteExamReg"/>
  </div>
</template>

<script>
import ShowMsg from '@/dialogs/ShowMsg'
import ShowMsgAtm from '@/dialogs/ShowMsgAtm'
import ShowConfirm from '@/dialogs/ShowConfirm'
import AdjustmentRegister from '@/dialogs/AdjustmentRegister'
import DeleteConfirm from '@/dialogs/DeleteConfirm'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.min.css';

export default {
  name: 'RegisterInformation',
  components: {ShowMsg, ShowMsgAtm, ShowConfirm, AdjustmentRegister, DeleteConfirm, Loading},
  mounted(){
    // this.tab = (this.$route.query.tab == '2') ? 2 : 0
    this.tab = (this.$route.query.tab == '1') ? 1 : (this.$route.query.tab == '2') ? 2 : 0
    this.memberType = (sessionStorage.getItem('cerpsMemberType').includes('erpMember')) ? 'erpMember' : 'erpTeacher'
    this.$Global.getNowTime().then(res=>{ this.nowTime = res })
    this.$Global.getFrontendAreaList().then(res=>{ this.frontendAreaList = res })
    this.$Global.getExamMethodList().then(res=>{ this.examMethodList = res })
    this.$Global.getApplyItemList().then(res=>{ this.applyItemList = res })
    this.$Global.getCollegeCategoryList().then(res=>{ this.collegeCategoryList = res })
    this.$Global.getHiTrustStoreList().then(res=>{ this.hiTrustStoreList = res })
    this.$Global.getHiTrustServiceList().then(res=>{ this.hiTrustServiceList = res })
    this.getDataset()
  },
  data:() => ({
    paymentMethod:['信用卡繳款','ATM、銀行郵局臨櫃繳款','LINE Pay','銀聯卡'],
    payment:'',
    expectPaymentMethod:'',
    datasets: [],
    payInfoList: [],
    viewStyle:{},
    tab:0,
    selectAll:false,
    mouseInfor:0,
    memberType:'',
    isLoading: false,

    orderBy:'id',
    direction:'desc',
    examination: [],
    certificateDeliveryList: [],
    frontendAreaList: [],
    examMethodList: [],
    applyItemList: [],
    collegeCategoryList: [],
    hiTrustStoreList: [],
    hiTrustServiceList: [],
    mOrderNumber:'',
    mOrderFee:0,

    companyInfo:'', //合併examCompany + examClassroom
    payGroup:'', //轉換
    examDate:'', //合併examDate + examTime
    examTimeNow:false, //true可以申請紙本證書 false還沒考試
    deadline:'', //合併deadlineDate + deadlineTime
    e17Date:'', //deadlineDate
    deadlineNow:false, //false不能繳費 + true可以繳費
    nowTime:'',
    browserName:'',
    platform:'',
    // couponHave:'0', //0無優惠券 1有優惠券
    // couponFix:false, //false未綁定 + true已綁定
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{
    // "couponHave":function(){
    //   if(this.couponHave == '0'){
    //     this.datasets.couponNo = null
    //     this.datasets.couponPrice = null
    //     this.datasets.havePay = this.datasets.feeType
    //   }
    //   if(this.couponHave == '1'){
    //     this.datasets.couponNo = ''
    //     this.datasets.couponPrice = ''
    //   }
    // },
  },
  computed: {},
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-128 + 'px'}
    },
    redirectPath(path, deliverId){
      this.$router.push({path: path, query: {
        id: this.$route.query.id,
        tab: this.tab,
        data: this.$Global.encrypt(JSON.stringify({
          class1: this.datasets.class1,
          class2: this.datasets.class2,
          class3: this.datasets.class3,
          examName: this.datasets.examName,
          examNo: this.datasets.examNo,
          examPass: this.datasets.examPass,
          examScore: this.datasets.examScore,
          idCard: this.datasets.idCard,
          name: this.datasets.name,
          sameRcvCert: 'true',
          ctel: this.datasets.ctel,
          email: this.datasets.email,
          zipCode: this.datasets.zipCode,
          country: this.datasets.country,
          area: this.datasets.area,
          address: this.datasets.address,
          certNo: this.datasets.certNo,
          citizenShip: this.datasets.citizenShip,
        })),
        deliverId: this.$Global.encrypt(JSON.stringify(deliverId)),
      }})
    },
    getCertificateDeliveryList(){
      var self = this
      var request = {
        method: 'GET',
        url: '/certificateDeliveryListByIdCardAndExamNo',
        params: {
          'examNo': self.datasets.examNo,
          'idCard': self.datasets.idCard,
          'limit':1000,
          'order': self.orderBy,
          'direction': self.direction,
        },
      }
      this.$http(request).then(function(response) {
        self.certificateDeliveryList = response.data.data
      }).catch(()=>{
        console.log('系統錯誤','請聯繫系統管理人員，編號為Rif-7956')
      }).finally(()=>{
        for(var i=0; i<self.certificateDeliveryList.length; i++){
          if(self.certificateDeliveryList[i].paymentMethod == '1' && self.certificateDeliveryList[i].paymentNo == '請至信箱收信或聯繫學會人員取得繳費帳號'){
            const promise = JSON.parse(self.certificateDeliveryList[i].orderId)
            for(var j=0; j<promise.length; j++){
              if(promise[j].payWay == '1'){
                self.getCertificateOrdernumber(i,self.certificateDeliveryList[i].paymentMethod,promise[j].orderId)
              }
            }
          }
        }
      })
    },
    async getCertificateOrdernumber(index,payType,orderId){
      let storeid = this.hiTrustStoreList[payType].storeid
      var self = this
      var request = {
        method: 'POST',
        url: '/TrustLink/QueryOnly?ordernumber=' + orderId + '&storeid=' + storeid + '&type=7' + '&examNo=' + this.datasets.examNo + '&idCard=' + this.datasets.idCard,
        params: {}
      }
      await this.$http(request).then(function(response) {
        if(response.data.data.e21){
          self.certificateDeliveryList[index].paymentNo = response.data.data.e21
        }else{
          self.certificateDeliveryList[index].paymentNo = ''
        }
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Mod-7967')
      }).finally(()=>{
      })
    },
    sort(field){
      this.orderBy = field
      this.direction = (this.direction == 'desc') ? 'asc' : 'desc'
      this.getDataset()
    },
    getDataset(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpExamReg/' + JSON.parse(this.$Global.decrypt(this.$route.query.id)),
        params: {
          id: JSON.parse(this.$Global.decrypt(this.$route.query.id)),
          source: 'cerpsMember',
        },
      }
      this.$http(request).then(function(response) {
        self.datasets = response.data.data
        self.getCertificateDeliveryList()
      }).catch(()=>{
        console.log('系統錯誤','請聯繫系統管理人員，編號為Rif-7957')
      }).finally(()=>{
        if(this.datasets.payGroup == '2' && this.datasets.paymentNo == '請至信箱收信或聯繫學會人員取得繳費帳號'){
          self.payInfoList = JSON.parse(self.datasets.orderId)
          const promises = []
          for(var i=0; i<self.payInfoList.length; i++){
            if(self.payInfoList[i].payWay == '1'){
              const promise = self.getOrdernumber(i,self.payInfoList[i].payWay,self.payInfoList[i].orderId)
              promises.push(promise)
            }else{
              self.payInfoList.splice(i, 1)
            }
          }
        }
        if(this.datasets.exportStatus =='4'){
          this.companyInfo = this.datasets.examCompany
        }else{
          this.companyInfo = this.datasets.examCompany + '-' + this.datasets.examClassroom
        }
        this.payGroup = (self.datasets.payGroup=='1') ? '團體繳費': (self.datasets.payGroup=='2') ? '個人繳費': ''
        this.examDate = self.datasets.examDate + ' ' + self.datasets.examTime
        this.deadline = self.datasets.deadlineDate + ' ' + self.datasets.deadlineTime
        this.mOrderFee = parseInt(self.datasets.havePay+'00')
        this.payment = (self.datasets.payType) ? self.datasets.payType : ''

        let time = this.datasets.examTime.split('-')
        this.examTimeNow = (new Date(this.nowTime) > new Date(this.datasets.examDate + 'T' +  time[0])) ? true : false
        // console.log('[A]this.deadline: ' + this.deadline)
        this.deadlineNow = (new Date(this.nowTime) < new Date(this.datasets.deadlineDate + 'T' + self.datasets.deadlineTime)) ? true : false
        // console.log('[A]this.deadlineNow: ' + this.deadlineNow)

        // if(this.datasets.couponNo){
        //   this.couponHave = '1'
        // }else{
        //   this.couponHave = '0'
        // }
        // if(this.datasets.couponPrice && this.datasets.couponPrice.length>0){
        //   this.couponFix = true
        // }else{
        //   this.couponFix = false
        // }
      })
    },
    // checkCouponNo(){
    //   if(this.datasets.couponNo.length <= 4 || this.datasets.couponNo.length >= 10){
    //     this.$refs.ShowMsg.open(0,'系統提示','認證折扣代碼不符合規範')
    //     return
    //   }
    //   if(this.datasets.couponPrice){
    //     this.$refs.ShowMsg.open(0,'系統提示','已綁定認證折扣代碼')
    //     return
    //   }
    //   var self = this
    //   var request = {
    //     method: 'GET',
    //     url: '/checkCoupon',
    //     params: {
    //       'couponNo': self.datasets.couponNo,
    //       'examNo': self.datasets.examNo,
    //       'id': self.datasets.id,
    //       'payGroup': '2', // 1-團體繳費 2-個人繳費
    //     },
    //   }
    //   this.$http(request).then(function(response) {
    //     console.log(response)
    //     if(response.data.msg == '成功!'){
    //       self.$refs.ShowMsg.open(0,'系統提示','折抵成功')
    //       self.getDataset()
    //     }else{
    //       self.$refs.ShowMsg.open(0,'系統提示',response.data.msg)
    //     }
    //   }).catch(()=>{
    //     self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Rif-7958')
    //   }).finally(()=>{
    //   })
    // },
    async getOrdernumber(index,payType,orderId){
      let storeid = this.hiTrustStoreList[payType].storeid
      var self = this
      var request = {
        method: 'POST',
        url: '/TrustLink/QueryOnly?ordernumber=' + orderId + '&storeid=' + storeid + '&type=7' + '&examNo=' + this.datasets.examNo + '&idCard=' + this.datasets.idCard,
        params: {}
      }
      await this.$http(request).then(function(response) {
        let havePay = []
        if(payType==1){
          havePay = response.data.data.approveamount.split('.')
        }
        if(payType!=1){
          havePay[0] = response.data.data.approveamount.substr(0,response.data.data.approveamount.length-2)
        }
        // console.log('ATM繳費碼: ' + response.data.data.e21)
        if(response.data.data.e21){
          if(self.datasets.paymentNo == '請至信箱收信或聯繫學會人員取得繳費帳號'){
            self.datasets.paymentNo = response.data.data.e21
          }else{
            self.datasets.paymentNo = self.datasets.paymentNo + '、' + response.data.data.e21
          }
        }
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Mod-7966')
      }).finally(()=>{
      })
    },
    setDataset(){
      if(this.payment=='1' && (!this.datasets.paymentNo || this.datasets.paymentNo=='')){
        this.datasets.paymentNo = '請至信箱收信或聯繫學會人員取得繳費帳號'
      }
      this.datasets.payType = this.payment
      var self = this
      var request = {
        method: 'PUT',
        url: '/erpExamRegPaymentNoAndPayTypeUpdate',
        // params: self.datasets,
        data: this.Qs.stringify(self.datasets),
      }
      this.$http(request).then(function(response) {
        // console.log(response)
        self.isLoading = true; //未更新
        self.createOrder()
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Rif-7958')
      }).finally(()=>{
      })
    },
    setCertificateDelivery(index){
      if(this.certificateDeliveryList[index].paymentMethod=='1' && !this.certificateDeliveryList[index].paymentNo){
        this.certificateDeliveryList[index].paymentNo = '請至信箱收信或聯繫學會人員取得繳費帳號'
      }
      var self = this
      var request = {
        method: 'PUT',
        url: '/certificateDeliveryPaymentNoAndPayTypeUpdate',
        data: this.Qs.stringify(self.certificateDeliveryList[index])
      }
      this.$http(request).then(function(response) {
        console.log(response)
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Rif-7959')
      }).finally(()=>{
        self.createApplyOrder(self.certificateDeliveryList[index].applyCode, self.certificateDeliveryList[index].applyFee, self.certificateDeliveryList[index].paymentMethod)
        // self.getCertificateDeliveryList()
      })
    },
    deleteExamReg(){
      var self = this
      var request = {
        method: 'PUT',
        url: '/erpExamRegStatusUpdate/' +  JSON.parse(this.$Global.decrypt(this.$route.query.id)),
        params: {},
      }
      this.$http(request).then(function(response) {
        // console.log(response)
        self.$refs.ShowMsg.open(0,'已刪除資料','您已刪除資料 !',true,true)
        self.$Global.setSystemLog(
          '', //ipAddress
          sessionStorage.getItem('cerpsMemberIdCard'), //userId
          'deleteExamRegStudent', //type
          self.datasets.examNo, //examNo
          JSON.parse(self.$Global.decrypt(self.$route.query.id)), //logContent
          '', //note1
        )
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Rif-7960')
      }).finally(()=>{
      })
    },
    browserVersion() {
      var UA = navigator.userAgent;
      var tMatch;
      var M = UA.match(/(OPERA|CHROME|SAFARI|FIREFOX|MSIE|TRIDENT(?=\/))\/?\s*(\d+)/i) || [];
      if (/TRIDENT/i.test(M[1])) {
        tMatch = /\brv[ :]+(\d+)/g.exec(UA) || [];
        return "IE " + (tMatch[1] || "");
      }
      if (M[1] === "Chrome") {
        tMatch = UA.match(/\b(OPR|Edg)\/(\d+)/);
        if (tMatch != null) {
          return tMatch.slice(1).join(" ").replace("OPR", "Opera").replace("Edg", "Edge");
        }
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
      if ((tMatch = UA.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tMatch[1]);
      return M.join(" ");
    },
    confirmOrder(){
      this.browserName = this.browserVersion()
      this.platform = navigator.platform
      let tmp = this.browserName + ' ' + this.platform

      this.$Global.setSystemLog(
        '2', //ipAddress
        sessionStorage.getItem('cerpsMemberIdCard'), //userId
        'payTime', //type
        this.datasets.examNo, //examNo
        '繳費監測', //logContent
        new Date(this.nowTime), //note1
        new Date(this.datasets.deadlineDate + 'T' + this.datasets.deadlineTime), //note2
        tmp, //note3
      )

      if(!this.deadlineNow){
        this.$refs.ShowMsg.open(0,'繳費期限逾期','請聯繫學會人員。')
        this.$Global.setSystemLog(
          '', //ipAddress
          sessionStorage.getItem('cerpsMemberIdCard'), //userId
          'deadlineNow', //type
          this.datasets.examNo, //examNo
          '繳費期限逾期', //logContent
          new Date(this.nowTime), //note1
          new Date(this.datasets.deadlineDate + 'T' + this.datasets.deadlineTime), //note2
          tmp, //note3
        )
        return
      }
      if(!this.payment || this.payment==''){
        this.$refs.ShowMsg.open(0,'請輸入所有必填','請選擇繳費方式 !')
        return
      }
      //未開通繳費方式
      if(this.payment=='2' || this.payment=='3'){
        this.$refs.ShowMsg.open(0,'繳費方式尚未開啟','請選擇「信用卡繳款」或「ATM、銀行郵局臨櫃繳款」繳費方式，感謝您的配合 !')
        this.payment=''
        return
      }
      //
      if(this.datasets.paymentNo && this.datasets.paymentNo != '請至信箱收信或聯繫學會人員取得繳費帳號' && this.payment=='1'){
        this.$refs.ShowMsgAtm.open(this.datasets.paymentNo)
        return
      }
      if(this.datasets.payType && this.payment != this.datasets.payType){
        this.$refs.ShowConfirm.open(0,'調整繳費方式','您原本選擇' + ((this.datasets.payType=='0') ? '信用卡繳款': (this.datasets.payType=='1') ? 'ATM、銀行郵局臨櫃繳款' : (this.datasets.payType=='2') ? 'LINE Pay': (this.datasets.payType=='3') ? '銀聯卡': '') + '為繳費方式，本次將繳費方式改為' + 
        ((this.payment=='0') ? '信用卡繳款': (this.payment=='1') ? 'ATM、銀行郵局臨櫃繳款' : (this.payment=='2') ? 'LINE Pay': (this.payment=='3') ? '銀聯卡': '') + '。系統將調整您設定的繳費方式，以便進行繳費。', true)
        return
      }
      if(!this.datasets.payType || this.payment == this.datasets.payType){
        this.setDataset()
      }
    },
    createOrder() {
      var self = this
      self.expectPaymentMethod = self.payment
      var orderData = {
        'examNo': self.datasets.examNo,
        'orderType': '1',
        'payWay': self.expectPaymentMethod,
        'mid': self.datasets.idCard,
        'fee': self.datasets.havePay,
        'havePay': self.datasets.realPay,
        'category': 'REG',
        'payType': self.datasets.payType
      }
      var request = {
        method: 'POST',
        url: '/erpOrder',
        data: this.Qs.stringify(orderData)
      }
      this.$http(request).then(function(response) {
        console.log(response);
        self.mOrderNumber = response.data.data;
      }).catch(()=>{
        // console.log(error);
        self.isLoading = false
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Rif-7961')
      }).finally(()=>{
        // setTimeout(() => {
        //   self.isLoading = false
        // },5000)
        setTimeout(() => {
          if (self.mOrderNumber.includes('hitrust')) {
            parent.window.location.replace(self.mOrderNumber);
          } else {
            self.startWI();
          }
          self.isLoading = false
        },5000)
      })
    },
    createApplyOrder(mApplyCode, mTotalPay, mPaymentMethod) {
      var self = this
      self.isLoading = true;
      self.mOrderFee = mTotalPay + '00'
      self.expectPaymentMethod = mPaymentMethod
      
        var orderData = {
          'examNo': self.datasets.examNo, // self.datasets.examNo  mApplyCode
          'note': mApplyCode,
          'orderType': '1',
          'payWay': self.expectPaymentMethod,
          'mid': self.datasets.idCard,
          'membersDetail': '',
          'fee': mTotalPay,
          'category': 'APPLY',
          'havePay': '1'
        }
      
      //console.log(orderData)
      
      var request = {
        method: 'POST',
        url: '/erpOrder',
        data: this.Qs.stringify(orderData)
      }
      this.$http(request).then(function(response) {
        console.log(response);
        self.mOrderNumber = response.data.data;
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Rif-7962')
      }).finally(()=>{
        setTimeout(() => {
          self.isLoading = false
        },5000)
        setTimeout(() => {
          if (self.mOrderNumber.includes('hitrust')) {
            parent.window.location.replace(self.mOrderNumber);
          } else {
            self.startWI();
          }
        },5000)
      })
    },
    getTranscriptPdf(){
      var self = this
      var request = {
        method: 'GET',
        url: '/transcriptDownload/exportpdf',
        params: {
          'id': this.datasets.id,
          'examNo': this.datasets.examNo,
          'idCard': this.datasets.idCard,
          'printType': 'member',
        },
        responseType: 'arraybuffer'
      }
      this.$http(request).then(function(response) {
        var blob = new Blob([response.data], { type: 'application/pdf' });
        // IE專用方法
        //window.navigator.msSaveBlob(blob, 'erpComeMoPage.pdf'); 
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = (self.datasets.examNo + '_成績單.pdf')
        link.click()
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Rif-7963')
      }).finally(function() {
      });
    },
    getReceiptPdf(){
      var self = this
      var request = {
        method: 'GET',
        url: '/receiptDownload/exportpdf',
        params: {
          'examNo': this.datasets.examNo,
          'idCard': this.datasets.idCard,
          'printType': 'member',
        },
        responseType: 'arraybuffer'
      }
      this.$http(request).then(function(response) {
        var blob = new Blob([response.data], { type: 'application/pdf' });
        // IE專用方法
        //window.navigator.msSaveBlob(blob, 'erpComeMoPage.pdf'); 
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = (self.datasets.examNo + '_收據.pdf')
        link.click()
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Rif-7964')
      }).finally(function() {
      });
    },
    getReceiptAppendPdf(id){
      var self = this
      var request = {
        method: 'GET',
        url: '/receiptAppendDownload/exportpdf',
        params: {
          'id': id,
          // 'examNo': data.examNo,
          // 'idCard': data.idCard,
          'printType': 'member',
        },
        responseType: 'arraybuffer'
      }
      this.$http(request).then(function(response) {
        var blob = new Blob([response.data], { type: 'application/pdf' });
        // IE專用方法
        //window.navigator.msSaveBlob(blob, 'erpComeMoPage.pdf'); 
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = (self.datasets.examNo + '_證書申請收據.pdf')
        link.click()
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Rif-7964')
      }).finally(function() {
      });
    },
    getCertificatePdf(){
      var self = this
      var request = {
        method: 'GET',
        url: '/certificateDownload/exportpdf',
        params: {
          'id': this.datasets.id,
          'examNo': this.datasets.examNo,
          'idCard': this.datasets.idCard,
          'printType': 'member',
        },
        responseType: 'arraybuffer'
      }
      this.$http(request).then(function(response) {
        var blob = new Blob([response.data], { type: 'application/pdf' });
        // IE專用方法
        //window.navigator.msSaveBlob(blob, 'erpComeMoPage.pdf'); 
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = (self.datasets.examNo + '_證書.pdf')
        link.click()
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Rif-7965')
      }).finally(function() {
      });
    },
    startWI() {
    this.$refs.submit.click();
    /*
      var self = this
      var postData = {
        'Type': 'Auth',
        'storeid': '50934',
        'ordernumber': self.mOrderNumber,
        'amount': self.datasets.examFee,
        'orderdesc': '認證鑑定費用',
        'depositflag': '1',
        'queryflag': '1',
        'pan':'',
        'expiry':'',
        'e01':'',
        'returnURL': 'https://13.114.173.137/Apply/#/registerInformationList',
        'merUpdateURL': 'http://13.114.173.137:8086/common/wiCcRecord'
      }
      var request = {
        method: 'POST',
        url: '/TrustLink/TrxReqForJava',
        data: this.Qs.stringify(postData)
      }
      this.$http(request).then(function(response) {
        console.log(response)
      }).catch(()=>{
      })
    */
    },
    onShowMsg(){
      this.redirectPath('/registerInformationList')
    },
    onShowMsgAtm(){
      this.redirectPath('/registerInformationList')
    },
    onShowConfirm(){
      this.setDataset()
    },
  }
}
</script>

<style>
  @media (max-width: 959px) {
    .menuApp {
      display: unset !important;
    }
    .menuWeb, .menuAppBtn {
      display: none !important;
    }
    .appBtn{
      display: unset !important;
    }
    .webBtn{
      display: none !important;
    }
    /* .tabsLeft .v-tabs-slider-wrapper{
      left: 0px !important;
    } */
  }
</style>